import { CourseType } from '../api';

export const hasLogoType = (course: CourseType) => {
  return course.title?.toLocaleLowerCase?.()?.includes?.('real estate');
};
